// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `footer .footer .footer__credits, footer .footer.footer__credits {
  background-color: var(--copyright-background);
}
footer .footer.position_bottom_centred {
  display: flex;
  justify-content: center;
  padding: 10px 15px;
  gap: 10px;
}
footer .footer .footer__newsletter {
  display: flex;
  flex-direction: column;
  /* Klaviyo style */
}
footer .footer .footer__newsletter .klaviyo-form {
  /* must be !important because app adds inline styles */
}
footer .footer .footer__newsletter .klaviyo-form input {
  border: none !important;
  border-bottom: 1px solid currentColor !important;
  padding: 0 !important;
  font-family: var(--font-body) !important;
}
footer .footer .footer__newsletter .klaviyo-form button {
  font-family: var(--font-body) !important;
  font-weight: var(--font-body-weight) !important;
}`, "",{"version":3,"sources":["webpack://./src/Common/components/shared.bundle/styles/footer.scss"],"names":[],"mappings":"AAII;EAEE,6CAAA;AAJN;AAQI;EACE,aAAA;EACA,uBAAA;EACA,kBAAA;EACA,SAAA;AANN;AAUI;EACE,aAAA;EACA,sBAAA;EAEA,kBAAA;AATN;AAUM;EACE,sDAAA;AARR;AASQ;EACE,uBAAA;EACA,gDAAA;EACA,qBAAA;EACA,wCAAA;AAPV;AAUQ;EACE,wCAAA;EACA,+CAAA;AARV","sourcesContent":["footer {\n  .footer {\n\n    // copy right background\n    .footer__credits,\n    &.footer__credits {\n      background-color: var(--copyright-background);\n    }\n\n    // position: bottom centred\n    &.position_bottom_centred {\n      display: flex;\n      justify-content: center;\n      padding: 10px 15px;\n      gap: 10px;\n    }\n\n    // newsletter\n    .footer__newsletter {\n      display: flex;\n      flex-direction: column;\n\n      /* Klaviyo style */\n      .klaviyo-form {\n        /* must be !important because app adds inline styles */\n        input {\n          border: none !important;\n          border-bottom: 1px solid currentColor !important;\n          padding: 0 !important;\n          font-family: var(--font-body) !important;\n        }\n        \n        button {\n          font-family: var(--font-body) !important;\n          font-weight: var(--font-body-weight) !important;\n        }\n      }\n    }\n  }\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
